import { Observable, Subscription } from 'rxjs';
import { Component, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import {
  NgcCookieConsentService,
  NgcInitializationErrorEvent,
  NgcInitializingEvent,
  NgcNoCookieLawEvent,
  NgcStatusChangeEvent,
} from 'ngx-cookieconsent';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { AuthServicesService } from './auth/services/auth-services.service';
import { ChatService } from './chat.service';
import { CreateOrderService } from './click-it/create-order/cement/Services/create-order.service';
import { MigrationPopupService } from './click-it/services/migration-popup.service';
import { UtilsService } from './shared/services/utils.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(window:resize)': 'onWindowResize($event)',
  },
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  onlineEvent!: Observable<Event>;
  offlineEvent!: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatusMessage: any;
  connectionStatus: any;
  localLanguage: any;
  title = 'af-notification';
  message: any = null;
  fireBaseToken: any;
  versionUpadted: boolean = false;
  isMobile = false;
  width: number = window.innerWidth;
  height: number = window.innerHeight;
  mobileWidth: number = 760;
  direction: any;
  businessData: any;
  userDetails: any;
  dashboardDetails: any;
  currentUrl: any;
  showWindowResize: boolean = true;
  showNavigationPopup: boolean = false;
  showSpinner: boolean = false;
  storeDataSubscribe: any;
  storeDataSubscribe2: any;
  chatEnable: boolean = false;
  showError: boolean = false;
  isHolcimUser: boolean = false;
  constructor(
    public translate: TranslateService,
    private store: Store<any>,
    private ccService: NgcCookieConsentService,
    private renderer: Renderer2,
    private router: Router,
    private swUpdate: SwUpdate,
    private auth: AuthServicesService,
    private chatService: ChatService,
    private createService: CreateOrderService,
    private utilService: UtilsService
  ) {
    if (!location.href.includes('localhost')) {
      this.getUpdate();
    }
    this.storeDataSubscribe = this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localLanguage = data?.authReducer?.localLanguage;
        this.businessData = data.authReducer?.businessDetails;
        this.userDetails = data?.authReducer?.userDetails;
        this.dashboardDetails = data?.authReducer?.dashboardDetails;
        this.chatEnable = data?.authReducer?.userDetails?.settings_data?.IS_CHAT_ENABLED ? data?.authReducer?.userDetails?.settings_data?.IS_CHAT_ENABLED : false;
        this.handleDirection();
        this.showWindowResize = data.cartReducer?.cartData?.isMobile;
      this.handleTranslate();
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showSpinner = true;
      }
      if (event instanceof NavigationEnd) {
        this.showSpinner = false;
      }
    });
    window.addEventListener('navigateFromSW', (event: any) => {
      const redirectUrl = event.detail;
      if (redirectUrl) {
        this.router.navigateByUrl(redirectUrl);
      }
    });
  }

  ngOnInit(): void {
    this.utilService.isHolcimUser$.subscribe(status => {
      this.isHolcimUser = status;
    });
    this.createService.showError.subscribe((res: any) => {
      if (res) {
        this.showError = true;
      }
    });
    if (this.showWindowResize) {
      if (this.width < this.mobileWidth) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
    localStorage.setItem('localLanguageCode', navigator.language)
    // Get the online/offline status from browser window
    this.subscriptions.push(
      this.ccService.popupOpen$.subscribe(() => { }),
      this.ccService.popupClose$.subscribe(() => { }),
      this.ccService.initializing$.subscribe(
        (event: NgcInitializingEvent) => { }
      ),
      this.ccService.initialized$.subscribe(() => { }),
      this.ccService.initializationError$.subscribe(
        (event: NgcInitializationErrorEvent) => { }
      ),
      this.ccService.statusChange$.subscribe((event: NgcStatusChangeEvent) => {
        localStorage.setItem('status', event.status);
        if (event.status === 'allow') {
          document.cookie = "cookieconsent_status=allow; path=/; domain=" + window.location.hostname + "; secure; samesite=Strict";
        }
      }),
      this.ccService.revokeChoice$.subscribe(() => { }),
      this.ccService.noCookieLaw$.subscribe((event: NgcNoCookieLawEvent) => { })
    );

    this.storeDataSubscribe2 = this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localLanguage = data?.authReducer?.localLanguage;
        this.translate.addLangs(['en', 'fr']);
        this.translate
          .get([
            'cookie-header',
            'cookie-message',
            'cookie-dismiss',
            'cookie-allow',
            'cookie-deny',
            'cookie-link',
            'cookie-policy',
          ])
          .subscribe((data) => {
            const config = this.ccService.getConfig();
            config.content = config?.content ?? {};
            // Override default messages with the translated ones
            if (config?.content) {
              config.content.header = data['cookie-header'];
              config.content.message = data['cookie-message'];
              config.content.dismiss = data['cookie-dismiss'];
              config.content.allow = data['cookie-allow'];
              config.content.deny = data['cookie-deny'];
              config.content.link = data['cookie-link'];
              config.content.policy = data['cookie-policy'];
            }
            this.ccService.destroy(); // remove previous cookie bar (with default messages)
            this.ccService.init(config); // update config with translated messages
          });
      });

    this.subscriptions.push(this.storeDataSubscribe, this.storeDataSubscribe2);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js?v=1.0.0')
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((err) => {
          console.log('Service Worker registration failed:', err);
        });
    }
  }

handleDirection(){
  if (((this.auth.isLoggedIn()) && (this.chatEnable)) && (!this.chatService.isConnected())) {
          this.chatService.connect();
        }
        if (this.localLanguage?.direction) {
          this.direction = this.localLanguage?.direction;
          localStorage.setItem('languageDirection', this.direction);
        } else if (localStorage.getItem('languageDirection') === 'undefined') {
          this.direction = 'ltr';
        } else {
          this.direction = localStorage.getItem('languageDirection');
        }
}

  handleTranslate() {
   if (this.localLanguage?.locale) {
          this.translate.use(this.localLanguage?.locale?.replace('-', ''));
        } else {
          this.translate.use('enGB');
        }
        this.direction = this.direction ? this.direction : 'ltr';
        this.renderer.removeClass(document.body, 'rtl');
        this.renderer.removeClass(document.body, 'ltr');
        this.renderer.addClass(document.body, this.direction);
        console.log(!location.href.includes('localhost'));

        if (
          !location.href.includes('localhost') &&
          !location.href.includes('aws-clickit-web-staging.clickitapp.io') &&
          !location.href.includes('aws-clickit-web-qa.clickitapp.io') &&
          !location.href.includes('web.clickitapp.io') &&
          (this.userDetails?.country?.locale == 'en-GB' ||
            this.userDetails?.country?.locale == 'fr-FR')
        ) {
          this.showNavigationPopup = false;
        }
  }
  //service-worker
  getUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.versionUpadted = true;
        }
      });
    }
  }


  movetoHolcim(event: any) {
    event.stopPropagation();
    const loginData = localStorage.getItem('loginData');
    const parsedData = loginData ? JSON.parse(loginData) : null;
    window.open(`${parsedData?.holcim_link}`, '_blank');
    localStorage.clear();
    localStorage.setItem('loginData',JSON.stringify(parsedData))
    // this.utilService.setHolcimUser(false);
  }
  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.height = event.target.innerHeight;
    if (this.showWindowResize) {
      if (this.width < this.mobileWidth) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  }

  NavigateToAWS(val: any) {
    const NavigateUrl = 'https://web.clickitapp.io/';
    if (val == 'anchor') {
      window.open(NavigateUrl, '_blank', 'noopener');
    } else if (val == 'button') {
      window.location.href = NavigateUrl;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
